export const isLegacyTemplateSelector = (state) => state.business.staticInfo.isLegacyTemplate;
export const isPublicTemplateSelector = (state) => state.business.staticInfo.isPublicTemplate;
export const templateIdSelector = (state) => state.business.templateId;